import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { observer } from 'mobx-react';
import { getService } from "../../provider/Service";
import { getArray, isObjectTruthy, safeReplace } from '../../utils/helpers';
import Pagination from '../../components/pagination';
import pages from '../../subscriber/Pages';
import SocialMedia from '../../components/socialMedia';
import SeoHelmet from '../../components/SeoHelmet';
import staticBlogs from '../../data/blogs.json';
import Layout from "../layout";

const ServiceDetail = () =>  {
    const { services } = pages
    const [serviceSlug, setServiceSlug] = useState(null);
    const [service, setService ] = useState({});
    const [prevservice, setPrevService] = useState(null);
    const [nextservice, setNextService] = useState(null);
    
    // const { getPageTranslations } = languageStore;
    // const social = getPageTranslations('social');
    const { slug } = useParams();
    
    useEffect(() => {
        setServiceSlug(slug);
    }, [slug]);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [serviceSlug]);

    useEffect(() => {
        const fetchService = async () => {
            if (serviceSlug) {
                const blogList = getArray(services);
                const currentIndex = blogList.findIndex(item => item.slug === serviceSlug);

                if (currentIndex === -1) {
                    const response = await getService(serviceSlug);
                    if (response) {
                        setService(response);
                    } else {
                        setService({});
                    }
                } else {
                    const currentService = blogList[currentIndex];
                    setService(currentService);

                    const prevService = currentIndex > 0 ? blogList[currentIndex - 1] : null;
                    const nextService = currentIndex < blogList.length - 1 ? blogList[currentIndex + 1] : null;

                    setPrevService(prevService);
                    setNextService(nextService);
                }
            }
        };
        
        fetchService();
    }, [serviceSlug, services]);

    // 👇 SEO meta only from staticService
    const seoService = staticBlogs.find(b => b.slug === slug);

    const updateSlug = (newSlug) => {
        setServiceSlug(newSlug)
    }

    return (
        <Layout>
            <SeoHelmet
                title={seoService?.name}
                description={seoService?.sort_description}
                image={seoService?.path}
                url={`${seoService?.url}`}
            />
            {isObjectTruthy(service) && (
                <div className="bg-[#FFF] min-h-screen">
                    {/* Hero Section */}
                    <section className="relative h-[60vh] md:h-[80vh] lg:h-[50vh] bg-cover bg-center" style={{backgroundImage: `url(${service.image})`}}>
                        <div className="absolute inset-0 bg-[#1F0707] opacity-40"></div>
                        <div className="container mx-auto px-4 h-full flex flex-col justify-center items-center relative z-10">
                            <h1 className="text-4xl font-['__Libre_Caslon_Display_7cf3ab'] md:text-5xl text-white font-bold text-center mb-4">{service.name}</h1>
                        </div>
                    </section>

                    {/* Main Content */}
                    <main className="container mx-auto px-4 py-16">
                        <div className="flex flex-wrap -mx-4">
                            <SocialMedia />

                            {/* Main Content */}
                            <div className="w-full md:w-8/12 px-4">
                                <article className="prose max-w-none">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: safeReplace(service.description, '../../asserts', '/asserts')
                                        }}
                                    />
                                </article>
                            </div>
                        </div>
                    </main>
                    {/* <SocialSection t={social}/> */}
                    <Pagination
                        prevLink={prevservice ? `${prevservice?.slug}` : ''}
                        prevTitle={prevservice?.name}
                        nextLink={nextservice ? `${nextservice?.slug}` : ''}
                        nextTitle={nextservice?.name}
                        onNavigate={updateSlug}
                    />
                </div>
            )}
        </Layout>
    );
}

export default observer(ServiceDetail);